// Key values that are repeated a lot
import { defaultFieldLogic } from 'AppSrc/core/components/forms/form-base-components/data-structure/default-field-logic';
import { CAUSED_SERVICE_OUTAGE, CORRECTIVE_ACTION_COMPLETION, MEASURES_NEEDED } from '../form-definition/section-constants';
// form fields
import { paragraphUnsuccessful } from './section-paragraph';
// import { causedChangeFail } from './caused-change-fail';
// import { impactServicesCustomers } from './impact_services_customers';
// import { impactedControl } from './impacted_control';
import { measuresNeeded } from './measures_needed';
import { correctiveAction } from './corrective-action';
import { correctiveActionOwner } from './corrective-action-owner';
import { correctiveActionOwnerName } from './corrective_action_owner_name';
import { correctiveActionOwnerEmail } from './corrective_action_owner_email';
import { correctiveActionOwnerMobileNumber } from './corrective_action_owner_mobile_number';
import { correctiveActionCompletion } from './corrective_action_completion';
import { expectedCompletionDate } from './expected_completion_date';
import { changeCoordinatorName } from './change-coordinator-name';
import { changeCoordinatorEmail } from './change-coordinator-email';
import { changeCoordinatorMobileNumber } from './change-coordinator-mobile-number';
import { changeImplementerEngineerName } from './change-implementation-engineer-name';
import { changeImplementerEngineerEmail } from './change-implementation-engineer-email';
import { causedServiceOutage } from './caused-service-outage';
import { durationOfOutage } from './duration-of-outage';
import { reasonForFailure } from './reason-for-failure';
// sub section titles
import { unsuccessfulChangeReview } from './sub-section-title';
import { contactDetails } from './contact-details';
import { changeImplementerEngineerMobileNumber } from './change-implementation-engineer-mobile';
import { reasonForFailureAndResultingImpact } from './reason-for-failure-and-resulting-impact';
import { associatedIncidentReference } from './associated-incident-reference';
import { whatWasAffected } from './what-was-affected';
import { rootcauseTitle } from './rootcause-title';
import { rootcauseSubtitle } from './rootcause-sub-title';
import { rootcauseParagraph } from './rootcause-paragraph';
import { rootcauseReasonone } from './rootcause-reason-one';
import { rootcauseReasontwo } from './rootcause-reason-two';
import { rootcauseReasonthree } from './rootcause-reason-three';

// This function is to clear the records of fields dependent on its parent field. If user modifies the value of parent field, it will clear the value of child's field.
const updateThisValueThenSetAffectedFieldsToInitialValue = (params) => {

  const {
    thisFieldId,
    affectedFields,
  } = params;

  return (callBackParams) => {
    const {
      form,
      newValue,
    } = callBackParams;

    const {
      setValues,
      values,
      setFieldTouched,
    } = form;

    const existingKeys = Object.keys(values);
    const oldValue = values[thisFieldId];

    // gets the old values for all of the form and mixes in the new value
    const newValues = {
      ...values,
      [thisFieldId]: newValue,
    };

    // defines the side affects we want this field to have
    const sideAffects = {};

    affectedFields.forEach((field) => {
      // sometimes we pass in components that are not relivant. ie, components that exist on fixed
      // but not mobile
      if (existingKeys.includes(field.id)) {
        sideAffects[field.id] = field.initialValues;
        // we're setting values here so it's a little aggresive to tell the user to fix them
        setFieldTouched(field.id, false);
        return null;
      }
      return null;
    });

    // defines a base of what the new state of the form will be
    let changeValues = {
      ...newValues,
    };

    // if the value has changed, add the side affects
    if (oldValue !== newValue) {
      changeValues = {
        ...newValues,
        ...sideAffects,
      };
    }

    // set the new form data with/without side affects
    setValues(changeValues);

    setFieldTouched(thisFieldId, true);
  };
};

// callback for the form section to figure out what fields to render with conditional logic
const getSectionFailureCurrentFields = ({
  values,
  network,
  // readOnly,
  // isOLO,
  // formData,
} = {}) => {
  let durationOfOutageShouldRender = false;
  let expectedDateShouldRender = false;
  let measuresNeededShouldEnabled = false;

  if (values) {
    const { [CAUSED_SERVICE_OUTAGE]: causedServiceOutageValue } = values;
    // For Fixed Line as well, we are sending Yes as value instead of 10 as its an free text field on Remedy side
    durationOfOutageShouldRender = causedServiceOutageValue ? causedServiceOutageValue.includes('Yes') : false;
    if (network === 'fixed') {
      durationOfOutageShouldRender = causedServiceOutageValue ? causedServiceOutageValue.includes('Yes') : false;
    }
    const { [CORRECTIVE_ACTION_COMPLETION]: correctiveActionCompletionValue } = values;
    expectedDateShouldRender = correctiveActionCompletionValue ? correctiveActionCompletionValue.includes('No') : false;
    if (network === 'fixed') {
      expectedDateShouldRender = correctiveActionCompletionValue ? correctiveActionCompletionValue.includes('No') : false;
    }
    const { [MEASURES_NEEDED]: measuresNeededValue } = values;
    measuresNeededShouldEnabled = !measuresNeededValue;
  }


  const currentFields = [
    {
      ...defaultFieldLogic,
      componentData: unsuccessfulChangeReview,
    },
    {
      ...defaultFieldLogic,
      componentData: paragraphUnsuccessful,
    },
    {
      ...defaultFieldLogic,
      componentData: contactDetails,
    },
    {
      ...defaultFieldLogic,
      componentData: {
        ...changeCoordinatorName,
      },
      shouldRender: true,
      shouldValidate: true,
      overwriteSubmit: {
        overwrite: false,
        overwriteValue: null,
      },
    },
    {
      ...defaultFieldLogic,
      componentData: {
        ...changeCoordinatorEmail,
      },
      shouldRender: true,
      shouldValidate: true,
      overwriteSubmit: {
        overwrite: false,
        overwriteValue: null,
      },
    },
    {
      ...defaultFieldLogic,
      componentData: {
        ...changeCoordinatorMobileNumber,
      },
      optional: true,
      shouldRender: true,
      shouldValidate: true,
      overwriteSubmit: {
        overwrite: false,
        overwriteValue: null,
      },
    },
    {
      ...defaultFieldLogic,
      componentData: {
        ...changeImplementerEngineerName,
      },
      shouldRender: true,
      shouldValidate: true,
      overwriteSubmit: {
        overwrite: false,
        overwriteValue: null,
      },
    },
    {
      ...defaultFieldLogic,
      componentData: {
        ...changeImplementerEngineerEmail,
      },
      shouldRender: true,
      shouldValidate: true,
      overwriteSubmit: {
        overwrite: false,
        overwriteValue: null,
      },
    },
    {
      ...defaultFieldLogic,
      componentData: {
        ...changeImplementerEngineerMobileNumber,
      },
      optional: true,
      shouldRender: true,
      shouldValidate: true,
      overwriteSubmit: {
        overwrite: false,
        overwriteValue: null,
      },
    },
    {
      ...defaultFieldLogic,
      componentData: reasonForFailureAndResultingImpact,
    },
    {
      ...defaultFieldLogic,
      componentData: {
        ...causedServiceOutage,
      },
      updateValue: updateThisValueThenSetAffectedFieldsToInitialValue({
        thisFieldId: causedServiceOutage.id,
        affectedFields: [
          durationOfOutage,
        ],
      }),
      shouldRender: true,
      shouldValidate: true,
      overwriteSubmit: {
        overwrite: false,
        overwriteValue: null,
      },
    },
    {
      ...defaultFieldLogic,
      componentData: {
        ...durationOfOutage,
      },
      shouldRender: durationOfOutageShouldRender,
    },
    {
      ...defaultFieldLogic,
      componentData: {
        ...reasonForFailure,
      },
      shouldRender: true,
      shouldValidate: true,
      overwriteSubmit: {
        overwrite: false,
        overwriteValue: null,
      },
    },
    {
      ...defaultFieldLogic,
      componentData: {
        ...associatedIncidentReference,
      },
      optional: true,
      shouldRender: true,
      shouldValidate: true,
      overwriteSubmit: {
        overwrite: false,
        overwriteValue: null,
      },
    },
    {
      ...defaultFieldLogic,
      componentData: {
        ...whatWasAffected,
      },
      optional: true,
      shouldRender: true,
      shouldValidate: true,
      overwriteSubmit: {
        overwrite: false,
        overwriteValue: null,
      },
    },
    {
      ...defaultFieldLogic,
      componentData: rootcauseTitle,
    },
    {
      ...defaultFieldLogic,
      componentData: rootcauseSubtitle,
    },
    {
      ...defaultFieldLogic,
      componentData: rootcauseParagraph,
    },
    {
      ...defaultFieldLogic,
      componentData: {
        ...rootcauseReasonone,
      },
    },
    {
      ...defaultFieldLogic,
      componentData: {
        ...rootcauseReasontwo,
        optional: true,
      },
    },
    {
      ...defaultFieldLogic,
      componentData: {
        ...rootcauseReasonthree,
        optional: true,
      },
    },
    {
      ...defaultFieldLogic,
      componentData: correctiveAction,
    },
    {
      ...defaultFieldLogic,
      componentData: {
        ...measuresNeeded,
      },
      shouldRender: true,
      shouldValidate: true,
      overwriteSubmit: {
        overwrite: false,
        overwriteValue: null,
      },
    },
    {
      ...defaultFieldLogic,
      componentData: correctiveActionOwner,
    },
    {
      ...defaultFieldLogic,
      componentData: {
        ...correctiveActionOwnerName,
      },
      shouldRender: true,
      shouldValidate: true,
      overwriteSubmit: {
        overwrite: false,
        overwriteValue: null,
      },
      disabledFieldOptions: {
        disabled: measuresNeededShouldEnabled,
        disabledValue: null,
        unDisabledValue: null,
      },
    },
    {
      ...defaultFieldLogic,
      componentData: {
        ...correctiveActionOwnerEmail,
        initialValues: null,
      },
      shouldRender: true,
      shouldValidate: true,
      overwriteSubmit: {
        overwrite: false,
        overwriteValue: null,
      },
      disabledFieldOptions: {
        disabled: measuresNeededShouldEnabled,
        disabledValue: null,
        unDisabledValue: null,
      },
    },
    {
      ...defaultFieldLogic,
      componentData: {
        ...correctiveActionOwnerMobileNumber,
      },
      shouldRender: true,
      shouldValidate: true,
      overwriteSubmit: {
        overwrite: false,
        overwriteValue: null,
      },
      disabledFieldOptions: {
        disabled: measuresNeededShouldEnabled,
        disabledValue: null,
        unDisabledValue: null,
      },
    },
    {
      ...defaultFieldLogic,
      componentData: {
        ...correctiveActionCompletion,
      },
      updateValue: updateThisValueThenSetAffectedFieldsToInitialValue({
        thisFieldId: correctiveActionCompletion.id,
        affectedFields: [
          expectedCompletionDate,
        ],
      }),
      shouldRender: true,
      shouldValidate: true,
      overwriteSubmit: {
        overwrite: false,
        overwriteValue: null,
      },
    },
    {
      ...defaultFieldLogic,
      componentData: {
        ...expectedCompletionDate,
      },
      shouldRender: expectedDateShouldRender,
      // shouldValidate: true,
      // overwriteSubmit: {
      //   overwrite: false,
      //   overwriteValue: null,
      // },
    },
    // {
    //   ...defaultFieldLogic,
    //   componentData: {
    //     ...causedChangeFail,
    //   },
    //   shouldRender: false,
    //   shouldValidate: true,
    //   overwriteSubmit: {
    //     overwrite: false,
    //     overwriteValue: null,
    //   },
    // },
    // {
    //   ...defaultFieldLogic,
    //   componentData: {
    //     ...impactServicesCustomers,
    //   },
    //   shouldRender: false,
    //   shouldValidate: true,
    //   overwriteSubmit: {
    //     overwrite: false,
    //     overwriteValue: null,
    //   },
    // },
    // {
    //   ...defaultFieldLogic,
    //   componentData: {
    //     ...impactedControl,
    //   },
    //   shouldRender: false,
    //   shouldValidate: true,
    //   overwriteSubmit: {
    //     overwrite: false,
    //     overwriteValue: null,
    //   },
    // },
  ];

  return currentFields;
};

export {
  getSectionFailureCurrentFields,
};
